import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 9v5a5 5 0 0 0 10 0v-5","key":"svg-0"}],["path",{"d":"M5 5h14","key":"svg-1"}]]

const IconOverline = createReactComponent('outline', 'overline', 'Overline', __iconNode);

export default IconOverline;